import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import SoftButton from "components/SoftButton";
import { Edit } from "@mui/icons-material";

export default function TableData({ data, handleActivateOffer, handleEditOffer }) {

  const tableMainData = {
    columns: [
      { name: "Name", align: "left" },
      { name: "Type", align: "left" },
      { name: "Offer Count", align: "center" },
      { name: "Start Date", align: "center" },
      { name: "End Date", align: "center" },
      { name: "Details", align: "center" },
      { name: "Status", align: "center" },
      { name: "Action", align: "center" },
    ],
    rows: [],
  };

  data && data.length > 0 && data.map((row) => {
    
    const IfFilledInformation = row?.locations.length > 0 && row?.passcode !="" && row?.savingPoints>0;

    tableMainData.rows.push({
      Name: (<SoftBox display="flex" alignItems="center" px={1} py={0.5}>
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography variant="button" fontWeight="medium">
            {row.name}
          </SoftTypography>
          <SoftTypography variant="caption" color="info">
            {row.org}
          </SoftTypography>
        </SoftBox>
      </SoftBox>),
      Type: (<SoftBox display="flex" flexDirection="column">
        <SoftTypography variant="caption" fontWeight="bold" color="text">
          {row.type}
        </SoftTypography>
        <SoftTypography variant="caption" color="info">
          {row.org}
        </SoftTypography>
      </SoftBox>),
      'Offer Count': (
        <SoftTypography variant="caption" fontWeight="medium">
          {row.usageCount}
        </SoftTypography>
      ),
      'Start Date': (
        <SoftTypography variant="caption" fontWeight="medium">
          {new Date(row.startDate).toDateString()}
        </SoftTypography>
      ),
      'End Date': (
        <SoftTypography variant="caption" fontWeight="medium">
          {new Date(row.endDate).toDateString()}
        </SoftTypography>
      ),
      Details: (
        <SoftButton
          href={`offerDetail/${row._id}`}
          variant="outlined" size="small" color="info">
          Details
        </SoftButton>
      ),

      Status: (
        row?.activeStatus == 1 ?
          <SoftBadge color="success" badgeContent="Active" size="lg" /> :
          <SoftButton
            onClick={() => (IfFilledInformation&&row?.templateId) && row?.locations.length > 0 ? handleActivateOffer(row?._id) : handleEditOffer(row?._id, row?.templateId ? 'edit' : 'create')}
            variant="gradient"
            color="info"
            size="small"
          >
            Activate
          </SoftButton>
      ),
      Action: (
        <SoftButton

          onClick={() => handleEditOffer(row._id, row?.templateId ? 'edit' : 'create')}
          variant="outlined" size="small" color="info">
          <Edit />
        </SoftButton>
      ),
    });
  });

  return tableMainData;

};









